import { CircleAlert, CircleCheck } from 'lucide-react'

import { UnderlinedTooltip } from 'components/ui/UnderlinedTooltip'

type Props = {
  confirmed: boolean
  year: number
}

export const MedicalPlanAvailabilityNotice = ({ confirmed, year }: Props) => {
  const tooltipContent = confirmed
    ? `This plan has been confirmed to be available in ${year} at this rate.`
    : `This plan is similar to one that was available in ${year - 1}, but is not guaranteed to exist in this configuration or rate in ${year}.`

  const tooltipClasses = confirmed ? 'text-green-800' : 'text-amber-500'

  return (
    <UnderlinedTooltip content={tooltipContent} className={tooltipClasses}>
      <div className='flex items-center gap-2'>
        {confirmed
          ? (
            <CircleCheck className='w-4 h-4' />
            )
          : (
            <CircleAlert className='w-4 h-4' />
            )}
        <span className='text-xs'>
          {confirmed ? 'Confirmed' : 'Example'} {year} plan
        </span>
      </div>
    </UnderlinedTooltip>
  )
}

export default MedicalPlanAvailabilityNotice
